module.exports = __webpack_public_path__ + "media/images/front/favicon-16x16-08d16e4dbc3282c4625082faca4a8a9d.png";